"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isInteger2 = _interopRequireDefault(require("lodash/isInteger"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Avatar = _interopRequireDefault(require("../../Clients/Avatar"));
var _Name = _interopRequireDefault(require("../../Clients/Name"));
var _TagList = _interopRequireDefault(require("../../Tags/TagList"));
var _TicketStatus = _interopRequireDefault(require("../TicketStatus"));
var _TicketType = _interopRequireWildcard(require("../TicketType"));
var _NewMessage = _interopRequireDefault(require("../../../../icons-react/NewMessage"));
var _AvatarCrown = _interopRequireDefault(require("../../../../icons-react/AvatarCrown"));
var _constants = require("../TicketStatus/constants");
var _Timer = _interopRequireDefault(require("../Timer"));
var _excluded = ["client", "ticket", "planReason"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var avatarPropTypes = _Avatar["default"].propTypes;
var nameType = avatarPropTypes.name,
  avatarUrlType = avatarPropTypes.url;
var tagListPropTypes = _TagList["default"].propTypes;
var tagsPropTypes = tagListPropTypes.tags;
var TicketStatusPropTypes = _TicketStatus["default"].propTypes;
var TicketCard = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var client = _ref.client,
    ticket = _ref.ticket,
    planReason = _ref.planReason,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!ticket) {
    return null;
  }
  var read = ticket.read,
    status = ticket.status,
    subject = ticket.subject,
    subtype = ticket.subtype,
    subAgentName = ticket.subAgentName,
    tags = ticket.tags,
    type = ticket.type,
    hasPriorityService = ticket.hasPriorityService,
    unreadMessengerAmount = ticket.unreadMessengerAmount,
    sla = ticket.sla,
    ltt = ticket.ltt,
    manager = ticket.manager,
    assignedAt = ticket.assignedAt,
    createdAt = ticket.createdAt,
    statusChangedAt = ticket.statusChangedAt;
  var time = status.time,
    title = status.title,
    priority = status.priority;
  var hasUnreadMessage = (0, _isInteger2["default"])(unreadMessengerAmount) && unreadMessengerAmount > 0;
  var clientName = (0, _get2["default"])(client, 'fullName') || 'Нет клиента';
  var avatarUrl = (0, _get2["default"])(client, 'avatarUrl');

  // из assignedAt и statusChangedAt выбираем ту дату, которая позже (assignedAt - в формате ISO, statusChangedAt - в секундах)
  var assignedAtDate = new Date(assignedAt);
  var statusChangedAtDate = new Date(statusChangedAt * 1000);
  var slaSubtrahendTime = (assignedAtDate > statusChangedAtDate ? assignedAtDate : statusChangedAtDate).toISOString();
  var lttSubtrahendTime = new Date(createdAt * 1000).toISOString();
  return /*#__PURE__*/_react["default"].createElement(StyledTicketCard, (0, _extends2["default"])({}, props, {
    read: read
  }), /*#__PURE__*/_react["default"].createElement(StyledHeader, null, /*#__PURE__*/_react["default"].createElement(StyledAvatarContainer, null, hasPriorityService && /*#__PURE__*/_react["default"].createElement(StyledAvatarCrownIcon, {
    width: 19,
    height: 14
  }), /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    name: clientName,
    url: avatarUrl
  })), /*#__PURE__*/_react["default"].createElement(StyledDescription, null, /*#__PURE__*/_react["default"].createElement(StyledName, {
    name: clientName
  }), /*#__PURE__*/_react["default"].createElement(StyledSubject, {
    title: subject
  }, subject), /*#__PURE__*/_react["default"].createElement(StyledTicketStatus, {
    planReason: planReason,
    priority: priority,
    time: time,
    title: title,
    placement: _constants.TICKET_STATUS_PLACEMENT.TICKET_CARD
  }), ltt && /*#__PURE__*/_react["default"].createElement(StyledLTTTime, {
    subtrahendTime: lttSubtrahendTime,
    seconds: ltt,
    type: "LTT"
  }), sla && manager && /*#__PURE__*/_react["default"].createElement(StyledSLATime, {
    subtrahendTime: slaSubtrahendTime,
    seconds: sla,
    type: "SLA"
  }))), /*#__PURE__*/_react["default"].createElement(StyledBody, null, /*#__PURE__*/_react["default"].createElement(StyledFirstBodyRow, null, /*#__PURE__*/_react["default"].createElement(StyledTicketType, {
    subtype: subtype,
    type: type
  }), /*#__PURE__*/_react["default"].createElement(StyledCountContainer, null, hasUnreadMessage && /*#__PURE__*/_react["default"].createElement(_NewMessage["default"], {
    width: 17
  }))), !!subAgentName && /*#__PURE__*/_react["default"].createElement(StyledSubAgentName, null, subAgentName), /*#__PURE__*/_react["default"].createElement(StyledTagList, {
    tags: tags,
    title: ((0, _isArray2["default"])(tags) ? tags : []).join(', ')
  })));
});
TicketCard.displayName = 'TicketCard';
TicketCard.propTypes = {
  className: _propTypes["default"].string,
  client: _propTypes["default"].shape({
    avatarUrl: avatarUrlType.isRequired,
    fullName: nameType.isRequired
  }).isRequired,
  ticket: _propTypes["default"].shape({
    read: _propTypes["default"].bool,
    hasPriorityService: _propTypes["default"].bool,
    subject: _propTypes["default"].string.isRequired,
    subtype: _propTypes["default"].oneOf(Object.values(_TicketType.SUBTYPES)),
    status: _propTypes["default"].shape(TicketStatusPropTypes).isRequired,
    tags: tagsPropTypes.isRequired,
    type: _propTypes["default"].oneOf(Object.values(_TicketType.TYPES)).isRequired,
    unreadEmailAmount: _propTypes["default"].number,
    unreadMessengerAmount: _propTypes["default"].number,
    orderIds: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired),
    closeReason: _propTypes["default"].string
  }).isRequired,
  planReason: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    title: _propTypes["default"].string
  })
};
TicketCard.defaultProps = {
  className: '',
  planReason: null
};
var StyledTicketCard = _styledComponents["default"].div.withConfig({
  displayName: "TicketCard__StyledTicketCard",
  componentId: "sc-pxsjgm-0"
})(["display:flex;flex-direction:column;padding:4px 10px;width:100%;"]);
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "TicketCard__StyledHeader",
  componentId: "sc-pxsjgm-1"
})(["display:flex;flex-shrink:0;height:72px;padding-right:10px;"]);
var StyledAvatarContainer = _styledComponents["default"].div.withConfig({
  displayName: "TicketCard__StyledAvatarContainer",
  componentId: "sc-pxsjgm-2"
})(["flex-shrink:0;margin:10px;margin-left:0;position:relative;"]);
var StyledAvatarCrownIcon = (0, _styledComponents["default"])(_AvatarCrown["default"]).withConfig({
  displayName: "TicketCard__StyledAvatarCrownIcon",
  componentId: "sc-pxsjgm-3"
})(["transform:rotate(-25deg);z-index:1;position:absolute;top:-8px;left:0px;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "TicketCard__StyledDescription",
  componentId: "sc-pxsjgm-4"
})(["flex-grow:1;overflow:hidden;"]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "TicketCard__StyledName",
  componentId: "sc-pxsjgm-5"
})(["color:#919499;font-size:12px;font-weight:normal;line-height:18px;margin-top:1px;"]);
var StyledSubject = _styledComponents["default"].div.withConfig({
  displayName: "TicketCard__StyledSubject",
  componentId: "sc-pxsjgm-6"
})(["color:#17181a;font-size:14px;font-weight:700;line-height:15px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var StyledTicketStatus = (0, _styledComponents["default"])(_TicketStatus["default"]).withConfig({
  displayName: "TicketCard__StyledTicketStatus",
  componentId: "sc-pxsjgm-7"
})(["margin-top:2px;flex-wrap:wrap;", "{width:100%;margin-left:0;}"], _TicketStatus["default"].StyledTimeFrom);
var StyledBody = _styledComponents["default"].div.withConfig({
  displayName: "TicketCard__StyledBody",
  componentId: "sc-pxsjgm-8"
})(["display:flex;margin-top:10px;flex-direction:column;flex-grow:1;"]);
var StyledFirstBodyRow = _styledComponents["default"].div.withConfig({
  displayName: "TicketCard__StyledFirstBodyRow",
  componentId: "sc-pxsjgm-9"
})(["display:flex;flex-shrink:0;justify-content:space-between;"]);
var StyledTicketType = (0, _styledComponents["default"])(_TicketType["default"]).withConfig({
  displayName: "TicketCard__StyledTicketType",
  componentId: "sc-pxsjgm-10"
})(["margin-right:12px;"]);
var StyledCountContainer = _styledComponents["default"].div.withConfig({
  displayName: "TicketCard__StyledCountContainer",
  componentId: "sc-pxsjgm-11"
})(["width:17px;display:flex;align-items:center;"]);
var StyledTagList = (0, _styledComponents["default"])(_TagList["default"]).withConfig({
  displayName: "TicketCard__StyledTagList",
  componentId: "sc-pxsjgm-12"
})(["color:#919499;display:block;height:17px;margin-top:5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var StyledSubAgentName = _styledComponents["default"].div.withConfig({
  displayName: "TicketCard__StyledSubAgentName",
  componentId: "sc-pxsjgm-13"
})(["font-size:13px;font-weight:700;color:#4b137b;margin:5px 0;"]);
var StyledSLATime = (0, _styledComponents["default"])(_Timer["default"]).withConfig({
  displayName: "TicketCard__StyledSLATime",
  componentId: "sc-pxsjgm-14"
})(["margin-bottom:5px;"]);
var StyledLTTTime = (0, _styledComponents["default"])(_Timer["default"]).withConfig({
  displayName: "TicketCard__StyledLTTTime",
  componentId: "sc-pxsjgm-15"
})(["margin:0 5px 5px 0;"]);
TicketCard.PRIORITIES = _constants.PRIORITIES;
TicketCard.TYPES = _TicketType.TYPES;
TicketCard.SUBTYPES = _TicketType.SUBTYPES;
var _default = exports["default"] = TicketCard;